// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, #e53e3e 0%, #9b2c2c 100%);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.game {
  width: 100%;
  max-width: 800px;
}

.game-header {
  text-align: center;
  margin-bottom: 30px;
}

.game-header h1 {
  color: white;
  font-size: 3rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 2px;
}

.game-container {
  display: flex;
  gap: 40px;
  justify-content: center;
  flex-wrap: wrap;
}

.game-board {
  width: 360px;
  max-width: 100%;
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.status {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
  min-height: 36px;
}

.board {
  width: fit-content;
  margin: 0 auto;
}

/* Dev test buttons for the Test 1 code hooks (App.js). */
.hook-buttons {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.hook-buttons button {
  flex: 1 1;
  padding: 7px 10px;
  font-size: 0.8rem;
  color: #4b5563;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: pointer;
}

.hook-buttons button:hover {
  border-color: #e53e3e;
  color: #333;
}

.agent-message {
  margin-top: 8px;
  font-size: 0.8rem;
  color: #4b5563;
  overflow-wrap: anywhere;
}

.board-row {
  display: flex;
}

.square {
  width: 80px;
  height: 80px;
  background: #f0f0f0;
  border: 3px solid #999;
  font-size: 2rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #333;
}

.square:hover {
  background: #e0e0e0;
  transform: scale(1.05);
}

.square:focus {
  outline: none;
  box-shadow: 0 0 10px rgba(229, 62, 62, 0.5);
}

.square.winning {
  background: #4caf50;
  color: white;
  animation: pulse 0.5s ease-in-out;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.restart-button {
  width: 100%;
  margin-top: 20px;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: bold;
  color: white;
  background: #e53e3e;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.restart-button:hover {
  background: #c53030;
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.3);
}

.restart-button:active {
  transform: translateY(0);
}

.game-info {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  width: 320px;
  max-width: 100%;
  max-height: 400px;
  overflow-y: auto;
}

.game-info h3 {
  color: #333;
  margin-bottom: 15px;
  font-size: 1.3rem;
  text-align: center;
}

.game-info ol {
  list-style: none;
  padding: 0;
}

.game-info li {
  margin-bottom: 8px;
}

.game-info button {
  width: 100%;
  padding: 10px 16px;
  font-size: 0.9rem;
  color: #333;
  background: #f0f0f0;
  border: 2px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.game-info button:hover {
  background: #e0e0e0;
  border-color: #e53e3e;
}

.game-info button.current-move {
  background: #e53e3e;
  color: white;
  font-weight: bold;
  border-color: #c53030;
}

/* Responsive design */
@media (max-width: 768px) {
  .game-header h1 {
    font-size: 2rem;
  }

  .game-container {
    flex-direction: column;
    align-items: center;
  }

  .square {
    width: 70px;
    height: 70px;
    font-size: 1.8rem;
  }

  .game-board,
  .game-info {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .square {
    width: 60px;
    height: 60px;
    font-size: 1.5rem;
  }

  .game-header h1 {
    font-size: 1.5rem;
  }
}

/* AI hint + result email (AiEmailPanel). Sits inside the white .game-board
   card, so every colour here is for a light background. */
.ai-panel {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ai-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.ai-panel-title {
  font-size: 0.75rem;
  font-weight: bold;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7280;
}

.ai-panel-status {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ai-badge {
  padding: 3px 8px;
  font-size: 0.72rem;
  font-weight: 600;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  white-space: nowrap;
}

.ai-badge-ok {
  background: #dcfce7;
  color: #166534;
}

.ai-badge-warn {
  background: #fef3c7;
  color: #92400e;
}

.ai-button {
  padding: 10px 16px;
  font-size: 0.9rem;
  font-weight: bold;
  color: white;
  background: #9b2c2c;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.ai-button:hover:not(:disabled) {
  background: #822727;
}

.ai-button-alt {
  background: #e53e3e;
}

.ai-button-alt:hover:not(:disabled) {
  background: #c53030;
}

.ai-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.ai-hint {
  margin: 0;
  padding: 8px 10px;
  font-size: 0.85rem;
  line-height: 1.4;
  color: #7f1d1d;
  background: #fef2f2;
  border-left: 3px solid #9b2c2c;
  border-radius: 6px;
}

.ai-email {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ai-email-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #374151;
}

.ai-email-input {
  width: 100%;
  padding: 9px 10px;
  font-size: 0.9rem;
  color: #111827;
  border: 1px solid #d1d5db;
  border-radius: 8px;
}

.ai-email-input:focus {
  outline: none;
  border-color: #e53e3e;
  box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.2);
}

.ai-email-actions {
  display: flex;
  gap: 8px;
}

.ai-email-actions .ai-button {
  flex: 1 1;
  padding: 10px 8px;
}

.ai-note {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.4;
  color: #6b7280;
  overflow-wrap: anywhere;
}

.ai-note-ok,
.ai-note-error,
.ai-note-busy {
  padding: 8px 10px;
  border-radius: 6px;
}

.ai-note-ok {
  color: #166534;
  background: #dcfce7;
}

.ai-note-error {
  color: #b91c1c;
  background: #fee2e2;
}

.ai-note-busy {
  color: #1e40af;
  background: #dbeafe;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;wEAEsE;EACtE,mCAAmC;EACnC,kCAAkC;EAClC,6DAA6D;EAC7D,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;0DAC0D;AAC1D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;;EAGE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: linear-gradient(135deg, #e53e3e 0%, #9b2c2c 100%);\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n\n.game {\n  width: 100%;\n  max-width: 800px;\n}\n\n.game-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.game-header h1 {\n  color: white;\n  font-size: 3rem;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  letter-spacing: 2px;\n}\n\n.game-container {\n  display: flex;\n  gap: 40px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.game-board {\n  width: 360px;\n  max-width: 100%;\n  background: white;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.status {\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #333;\n  min-height: 36px;\n}\n\n.board {\n  width: fit-content;\n  margin: 0 auto;\n}\n\n/* Dev test buttons for the Test 1 code hooks (App.js). */\n.hook-buttons {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.hook-buttons button {\n  flex: 1;\n  padding: 7px 10px;\n  font-size: 0.8rem;\n  color: #4b5563;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.hook-buttons button:hover {\n  border-color: #e53e3e;\n  color: #333;\n}\n\n.agent-message {\n  margin-top: 8px;\n  font-size: 0.8rem;\n  color: #4b5563;\n  overflow-wrap: anywhere;\n}\n\n.board-row {\n  display: flex;\n}\n\n.square {\n  width: 80px;\n  height: 80px;\n  background: #f0f0f0;\n  border: 3px solid #999;\n  font-size: 2rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #333;\n}\n\n.square:hover {\n  background: #e0e0e0;\n  transform: scale(1.05);\n}\n\n.square:focus {\n  outline: none;\n  box-shadow: 0 0 10px rgba(229, 62, 62, 0.5);\n}\n\n.square.winning {\n  background: #4caf50;\n  color: white;\n  animation: pulse 0.5s ease-in-out;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n.restart-button {\n  width: 100%;\n  margin-top: 20px;\n  padding: 12px 24px;\n  font-size: 1rem;\n  font-weight: bold;\n  color: white;\n  background: #e53e3e;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.restart-button:hover {\n  background: #c53030;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.3);\n}\n\n.restart-button:active {\n  transform: translateY(0);\n}\n\n.game-info {\n  background: white;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  width: 320px;\n  max-width: 100%;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.game-info h3 {\n  color: #333;\n  margin-bottom: 15px;\n  font-size: 1.3rem;\n  text-align: center;\n}\n\n.game-info ol {\n  list-style: none;\n  padding: 0;\n}\n\n.game-info li {\n  margin-bottom: 8px;\n}\n\n.game-info button {\n  width: 100%;\n  padding: 10px 16px;\n  font-size: 0.9rem;\n  color: #333;\n  background: #f0f0f0;\n  border: 2px solid transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.game-info button:hover {\n  background: #e0e0e0;\n  border-color: #e53e3e;\n}\n\n.game-info button.current-move {\n  background: #e53e3e;\n  color: white;\n  font-weight: bold;\n  border-color: #c53030;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .game-header h1 {\n    font-size: 2rem;\n  }\n\n  .game-container {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .square {\n    width: 70px;\n    height: 70px;\n    font-size: 1.8rem;\n  }\n\n  .game-board,\n  .game-info {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .square {\n    width: 60px;\n    height: 60px;\n    font-size: 1.5rem;\n  }\n\n  .game-header h1 {\n    font-size: 1.5rem;\n  }\n}\n\n/* AI hint + result email (AiEmailPanel). Sits inside the white .game-board\n   card, so every colour here is for a light background. */\n.ai-panel {\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ai-panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.ai-panel-title {\n  font-size: 0.75rem;\n  font-weight: bold;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #6b7280;\n}\n\n.ai-panel-status {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.ai-badge {\n  padding: 3px 8px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #475569;\n  white-space: nowrap;\n}\n\n.ai-badge-ok {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.ai-badge-warn {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.ai-button {\n  padding: 10px 16px;\n  font-size: 0.9rem;\n  font-weight: bold;\n  color: white;\n  background: #9b2c2c;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.ai-button:hover:not(:disabled) {\n  background: #822727;\n}\n\n.ai-button-alt {\n  background: #e53e3e;\n}\n\n.ai-button-alt:hover:not(:disabled) {\n  background: #c53030;\n}\n\n.ai-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.ai-hint {\n  margin: 0;\n  padding: 8px 10px;\n  font-size: 0.85rem;\n  line-height: 1.4;\n  color: #7f1d1d;\n  background: #fef2f2;\n  border-left: 3px solid #9b2c2c;\n  border-radius: 6px;\n}\n\n.ai-email {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ai-email-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.ai-email-input {\n  width: 100%;\n  padding: 9px 10px;\n  font-size: 0.9rem;\n  color: #111827;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n}\n\n.ai-email-input:focus {\n  outline: none;\n  border-color: #e53e3e;\n  box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.2);\n}\n\n.ai-email-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.ai-email-actions .ai-button {\n  flex: 1;\n  padding: 10px 8px;\n}\n\n.ai-note {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  color: #6b7280;\n  overflow-wrap: anywhere;\n}\n\n.ai-note-ok,\n.ai-note-error,\n.ai-note-busy {\n  padding: 8px 10px;\n  border-radius: 6px;\n}\n\n.ai-note-ok {\n  color: #166534;\n  background: #dcfce7;\n}\n\n.ai-note-error {\n  color: #b91c1c;\n  background: #fee2e2;\n}\n\n.ai-note-busy {\n  color: #1e40af;\n  background: #dbeafe;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
